import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "M6 4.046h13.818v13.46l-3.589.448V7.635H6.36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.621 3.7a.7.7 0 0 1 .7-.7h13.98a.7.7 0 0 1 .7.7v13.979a.7.7 0 0 1-.7.7h-3.087V20.3a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V7.486a.7.7 0 0 1 .7-.7h1.943a.7.7 0 0 1-.022-.174zM7 6.786h9.515a.7.7 0 0 1 .7.7v9.493H19.6V4.4H7.021v2.212q0 .09-.022.174M4.4 8.186v7.41c2.507-1.078 7.027-1.982 11.414-.578V8.186zm11.414 8.31c-4.388-1.577-9.074-.505-11.28.58a.7.7 0 0 1-.134.049V19.6h11.414z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.485 11.386a1.024 1.024 0 1 1-2.048 0 1.024 1.024 0 0 1 2.048 0"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ContentLibraryIcon24.js.map